__turbopack_context__.v({
  "logo": "logo-module-scss-module__xrDn6W__logo",
  "logoMobile": "logo-module-scss-module__xrDn6W__logoMobile",
  "mobileLogoContainer": "logo-module-scss-module__xrDn6W__mobileLogoContainer",
});
